import React from "react";
import { CardInfo } from "./CardInfo";

export const Footer = () => {
  return (
    <>
      <CardInfo />
    </>
  );
};
